<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'inventory_items.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field">
   

      <!-- <button mat-button aria-label="option menu"
      [matMenuTriggerFor]="menu" color="accent" >
        <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
      </button> -->
      <div class="create_btn_sd">
        <button mat-icon-button color="primary" aria-label="option menu" *ngIf="isOwner"
        [matMenuTriggerFor]="menu">
            <mat-icon>add</mat-icon> 
            <!-- Inventory  -->
        </button>
    </div>

      <mat-menu #menu="matMenu">
        <button  mat-menu-item (click)="onCreateNewService()">
          <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
          <span>Add item manually</span>
        </button>
        <button  mat-menu-item (click)="onCreateNewServiceFromTemplate()">
          <mat-icon class="material-icons-outlined">library_add</mat-icon>
          <span>{{ 'inventory_items.btn_txt2' | translate }}</span>
        </button>
       
      </mat-menu>
    </div>
  </ng-template>
</sm-title-bar>


<div style="margin-bottom: 10px;" *ngIf="!loader">
  <!-- <sm-title-bar pageSubTitle="Inventory Activity"></sm-title-bar> -->
  <mat-form-field appearance="outline" class="me-2">
    <mat-label>{{ 'inventory_items.search_label' | translate }}</mat-label>
    <input
    [formControl]="searchString"
     
      matInput
      placeholder="{{ 'inventory_items.search_placeholder' | translate }}"
      (keyup)="searchServiceData()"
    />
    <button
      mat-button
      *ngIf="!searchString.value"
      matSuffix

      aria-label="Clear"
    >
      <mat-icon>search</mat-icon>
    </button>
    <button
    mat-button
    *ngIf="searchString.value"
    matSuffix
   
    aria-label="Clear"
    (click)="reset()"
  >
    <mat-icon>close</mat-icon>
  </button>
  </mat-form-field>
  <!-- <div class="rounded-3 bg-light" *ngIf="!loader && inventoryItemsData.length >0">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="inventoryItemsData" [showImageColumn]="true"  [imageTemplate]="image" [showMenuButton]="isOwner" [menuDropdownTemplate]="menuTemplate"></sm-data-table>
  </div> -->
</div>


<div class="service_card_sedf" *ngIf="!loader && inventoryItemsData.length >0">
  <div class="row">
      <div class="col-sm-6 col-md-6 col-12" *ngFor="let item of inventoryItemsData">
          <div class="serv_sect">
      <mat-card appearance="outlined" class="service-card">
        <mat-card-header class="hy_secf">
          <div mat-card-avatar class="header-avatar">
            <div class="dot_ser" [ngStyle]="{'background-color': item.current_purchase_stock <= 0 || item.current_purchase_stock == null
    ? 'red'
    : item.current_purchase_stock > 0 && item.current_purchase_stock <= item.min_stock
        ? 'yellow'
        : 'green'}" ></div>
              <div class="booking-initial" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">{{item.item_name.slice(0,1).toUpperCase()}}</div>
              <img *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'" [src]="item.image_thumb_url" onerror="this.src='../../../../assets/images/photo.png'" alt="Service image">
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options" *ngIf="isOwner">
              <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu2="matMenu">
            <button mat-menu-item (click)="editInventoryItem(item)" [disabled]="!isOwner">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span>{{ 'inventory_items.op1_edit' | translate }}</span>
            </button>
            <button mat-menu-item (click)="deleteInventoryItem(item)" [disabled]="!isOwner">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>{{ 'inventory_items.op2_delete' | translate }}</span>
            </button>
          </mat-menu>
          
      </mat-card-header>
      <mat-card-content>
          <div class="header_ftgt">
              <mat-card-title>{{item.item_name}}</mat-card-title>
              <mat-card-subtitle>Purchase unit: {{item.purchase_unit}}</mat-card-subtitle>
              <mat-card-subtitle>Selling unit: {{item.s_unit}}</mat-card-subtitle>
              <mat-card-subtitle>Current stock: {{item.c_stock}}</mat-card-subtitle>
          </div>
         
         
          <!-- <p class="description">
              {{item.product_desc | ellipsify: 80}}
          </p> -->
      </mat-card-content>

  </mat-card>
</div>
</div>




<!--  -->




</div>
</div>



<ng-template #menuTemplate let-rowvalue>
  
  <button mat-menu-item (click)="editInventoryItem(rowvalue)" [disabled]="!isOwner">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>{{ 'inventory_items.op1_edit' | translate }}</span>
  </button>
  <button mat-menu-item (click)="deleteInventoryItem(rowvalue)" [disabled]="!isOwner">
    <mat-icon class="material-icons-outlined">delete</mat-icon>
    <span>{{ 'inventory_items.op2_delete' | translate }}</span>
  </button>
  
</ng-template>

<ng-template #image let-objValue>
  <div style="position: relative;">
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : '../../../../assets/images/photo.png'
      "
      class="img-fluid rounded-circle" style="border: 1px solid lightgray;"
    />
    <span style="height: 15px; width: 15px; background-color: red; border-radius: 50%; display: block; position: absolute;bottom: -3px;
    left: 28px;" [ngStyle]="{'background-color': objValue['current_purchase_stock'] == 0 || objValue['current_purchase_stock'] == null
    ? 'red'
    : objValue['current_purchase_stock'] > 0 && objValue['current_purchase_stock'] <= objValue['min_stock']
        ? 'yellow'
        : 'green'}">
  
    </span>
  </div>
</ng-template>

<mat-paginator
*ngIf="!loader && inventoryItemsData.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>

  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && inventoryItemsData.length == 0">
    <div class="row">
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/inventory-item.jpg">
             </div>
             <mat-card-title>No inventory item
            </mat-card-title>
             <mat-card-content style="padding-top: 0px;">The business haven't added any inventory item yet. Once you start adding them, the list will show here with details
            </mat-card-content>
             <div class="watch_vc_btn">
              <button mat-flat-button color="primary" mat-button aria-label="option menu" *ngIf="isOwner"
              [matMenuTriggerFor]="menu">
                  <mat-icon>add</mat-icon> 
                  Add item
              </button>
             </div>
             <mat-menu #menu="matMenu">
              <button  mat-menu-item (click)="onCreateNewService()">
                <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
                <span>Add item manually</span>
              </button>
              <button  mat-menu-item (click)="onCreateNewServiceFromTemplate()">
                <mat-icon class="material-icons-outlined">library_add</mat-icon>
                <span>{{ 'inventory_items.btn_txt2' | translate }}</span>
              </button>
             
            </mat-menu>
             </div>
          </mat-card>
       </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/helpsupport.png">
             </div>
             <mat-card-title>Facing any issue?</mat-card-title>
             <mat-card-content style="padding-top: 0px;">For any difficulties in adding new inventory item or if there's any issue with the item details, contact support team.
            </mat-card-content>
             <div class="watch_vc_btn">
                <button mat-stroked-button color="primary"  (click)="opencontact()">
                   <mat-icon>support_agent</mat-icon>
                   Contact support 
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
    </div>
</div> 
<!-- placeholder html end -->
